import { createStyles } from "antd-style";
import { ospThemes } from "@ospweb/sdk-ui";

// thHeight - 1 解决1px间隙问题

export const useStyles = createStyles(
  (
    { css, prefixCls, responsive },
    {
      thHeight = 40,
      padding,
    }: { thHeight?: number; padding?: number | string } = {},
  ) => {
    const hasPadding = typeof padding !== "undefined";
    return {
      // ant-table-body
      tableCustom: css`
        .${prefixCls}-table {
          background: ${ospThemes.colors.background_solid_secondary};
          padding: ${hasPadding ? padding : "0 calc(60px - 8px)"};

          ${responsive.md} {
            padding: 0 16px;
          }

          .${prefixCls}-table-sticky-holder {
            background: ${ospThemes.colors.background_solid_secondary};
          }

          .${prefixCls}-table-header {
            height: ${thHeight - 1}px;
          }

          /* Header styles */
          &-thead {
            > tr {
              > th {
                font-weight: 500;
                padding: 12px 8px;
                height: ${thHeight}px;
                color: ${ospThemes.colors.content_secondary};
              }
            }
            ${responsive.mobile} {
              &::after {
                content: "";
                display: none;
              }
            }
          }

          /* Body styles */
          &-tbody {
            > tr {
              > td {
                height: 52px;
                padding: 8px;
                border-radius: 0 !important;
              }
              /* 吸顶的时候，要索引第二行的边框 */
              ${responsive.mobile} {
                &:nth-child(2) {
                  border-top: none;
                  > td {
                    border-top: none;
                  }
                }
              }
            }
          }
        }
      `,
      tableRowCursor: css`
        .${prefixCls}-table {
          &-tbody {
            > tr {
              cursor: pointer;
            }

            .${prefixCls}-table-row {
              > .${prefixCls}-table-cell-row-hover {
                background-color: var(--edgen-background_solid_tertiary);
              }
            }
          }
        }
      `,

      tableCustomNoBorder: css`
        .${prefixCls}-table {
          &-thead {
            > tr > th {
              border-bottom: none;
            }
            :after {
              content: "";
              display: none;
            }
          }
          /* Body styles */
          &-tbody {
            > tr {
              position: relative;
              border-top: none;
              &:not(:last-child) {
                > td {
                  border-top: none !important;
                  border-bottom: 1px solid
                    var(--edgen-border_white_transparent10) !important;
                }
              }
              &:first-child {
                > td {
                  border-top: none;
                }
              }
              &:last-child {
                > td {
                  border-top: none !important;
                  border-bottom: none !important;
                }
              }

              > td {
                &:first-child {
                  border-left: none !important;
                }

                &:last-child {
                  border-right: none !important;
                }
              }
            }

            .${prefixCls}-table-row {
              border-top: none;
            }
          }
        }
      `,
    };
  },
);
